<template>
  <header class="header">
    <div class="header-container">
      <!-- 로고 부분 -->
      <div class="logo">
        <a href="#" style="width: 53px" @click.prevent="handleLogoClick">
          <img src="@/assets/images/sgate_bot_icon.png" class="w-50" alt="SGate Logo" />
        </a>
        <!-- 타이틀 부분 -->
        <div class="title-area" @click="handlePageRefresh">
          <h1 class="title">{{ pageTitle }}</h1>
          <!-- 유튜브 링크 부분 주석처리 -->
          <!-- <a
            v-if="currentMenuItem && isNotEmpty(currentMenuItem.linkUrl)"
            :href="currentMenuItem.linkUrl"
            target="_blank"
            rel="noopener noreferrer"
            :class="[
              'flex',
              'gap-10',
              'items-center',
              'has-link',
              { 'has-link-trail': isNotEmpty(currentMenuItem.manualUrl) },
            ]"
            @click.stop
          >
            <i class="icon icon-youtube icon-lg"></i>
          </a> -->
          <a
            v-if="currentMenuItem && isNotEmpty(currentMenuItem.manualUrl)"
            href="javascript:void(0);"
            class="has-link"
            :title="t('common.header.manualOpenInNewWindow')"
            @click.prevent.stop="openManualUrl"
          >
            <Icon name="heroicons:book-open" size="16" />
            <span class="has-link__label">{{ t('common.header.manual') }}</span>
            <Icon class="has-link__ext" name="heroicons:arrow-up-right" size="13" />
          </a>
        </div>
      </div>

      <!-- 동적 탭 메뉴 부분 -->
      <div v-if="currentTabMenu.length > 0" class="tab-menu">
        <div class="tabs">
          <button
            v-for="(tab, index) in currentTabMenu"
            :key="tab.name"
            class="tab"
            :class="{ active: index === activeTab }"
            @click="handleTabClick(index)"
          >
            {{ tab.name }}
          </button>
        </div>
      </div>

      <!-- 우측 아이콘 메뉴 -->
      <div class="icon-menu">
        <!-- 전체관리자(01) 권한일 때만 문의하기(SSO) 노출 -->
<!--        <button
          v-if="auth.hasAuthority('01')"
          class="asis-shortcut-btn asis-shortcut-btn&#45;&#45;report"
          type="button"
          @click="goSrsysSsoLogin()"
        >
          <Icon name="heroicons:arrow-top-right-on-square" size="16" />
          <span>{{ t('common.header.errorImprovementReport') }}</span>
        </button>-->

        <!-- v-if="auth.user?.compId === 'ispark'" -->
        <button
          class="asis-shortcut-btn asis-shortcut-btn--asis"
          type="button"
          @click="goAsisService()"
        >
          <Icon name="heroicons:arrow-top-right-on-square" size="16" />
          <span>{{ t('common.header.useLegacySgate') }}</span>
        </button>
        <div v-if="showCompIcon" class="main-logo">
          <img :src="compIconUrl" alt="logo" />
        </div>
        <!-- SAI 챗봇: 고객사 SAI 사용(compSaiUseYn=Y)이고, 전체관리자(01) 또는 고객사 ID가 ISPARK일 때 노출 -->
        <!-- 개인 설정(aiSaiUseYn) 체크: v-if="betaFeatures?.sai && auth.hasAuthority('01')" -->
        <button
          v-if="compSaiUseYn === 'Y' && (auth.hasAuthority('01') || auth.user?.compId?.toLowerCase() === 'ispark')"
          class="icon-button sai-button"
          title="SAI"
          @click="saiChatStore.openSaiModal"
        >
          <span class="sai-beta-badge">Beta</span>
          <img src="/images/sai_icon.svg" alt="AI" style="width: 25px; height: 25px" />
        </button>

        <!-- SSO 연동서비스 바로가기 -->
        <div v-if="ssoServiceOptions.length > 0" class="sso-service-select">
          <UiSelect
            v-model="ssoServiceId"
            :options="ssoServiceOptions"
            :placeholder="t('common.header.ssoServiceShortcut')"
            size="small"
            width="160px"
            @change="handleSsoLogin"
          />
        </div>

        <!-- 더보기 드롭다운: 전체메뉴/공지/Q&A/매뉴얼/자주 묻는 질문 -->
        <div ref="helpMenuRef" class="help-menu">
          <button class="icon-button" :title="t('common.header.more')" :class="{ 'is-active': isHelpMenuOpen }" @click="toggleHelpMenu">
            <Icon name="heroicons:ellipsis-horizontal" size="22" />
          </button>
          <ul v-show="isHelpMenuOpen" class="help-menu__dropdown">
            <li>
              <button
                class="help-menu__item"
                type="button"
                @click="
                  closeHelpMenu();
                  openModal('fullMenu');
                "
              >
                <Icon class="help-menu__icon" name="heroicons:squares-2x2" size="18" />
                <span class="help-menu__label">{{ t('common.header.fullMenu') }}</span>
                <Icon class="help-menu__chevron" name="heroicons:chevron-right" size="16" />
              </button>
            </li>
            <li>
              <button
                class="help-menu__item"
                type="button"
                @click="
                  closeHelpMenu();
                  popNotice();
                "
              >
                <Icon class="help-menu__icon" name="heroicons:megaphone" size="18" />
                <span class="help-menu__label">{{ t('common.header.notice') }}</span>
                <Icon class="help-menu__chevron" name="heroicons:chevron-right" size="16" />
              </button>
            </li>
            <li>
              <button
                class="help-menu__item"
                type="button"
                @click="
                  closeHelpMenu();
                  popQnA();
                "
              >
                <Icon class="help-menu__icon" name="heroicons:chat-bubble-left-right" size="18" />
                <span class="help-menu__label">{{ t('common.header.qna') }}</span>
                <Icon class="help-menu__chevron" name="heroicons:chevron-right" size="16" />
              </button>
            </li>
            <li>
              <button class="help-menu__item" type="button" @click="closeHelpMenu(); openManualPopup()">
                <Icon class="help-menu__icon" name="heroicons:book-open" size="18" />
                <span class="help-menu__label">{{ t('common.header.manual') }}</span>
                <Icon class="help-menu__chevron" name="heroicons:chevron-right" size="16" />
              </button>
            </li>
            <li>
              <button class="help-menu__item" type="button" @click="closeHelpMenu(); openFaqPopup()">
                <Icon class="help-menu__icon" name="heroicons:question-mark-circle" size="18" />
                <span class="help-menu__label">{{ t('common.header.faq') }}</span>
                <Icon class="help-menu__chevron" name="heroicons:chevron-right" size="16" />
              </button>
            </li>
          </ul>
        </div>

        <!-- 아바타 (order 2) -->
        <div style="order: 2">
          <UiTooltip position="bottom-right">
            <template #trigger>
              <button class="icon-button" @click="openUserInfoModal">
                <UserImg :user-info="userInfo" :user-name="userInfo?.name" :size="28" />
              </button>
            </template>
            {{ userProfileTooltip }}
          </UiTooltip>
          <UiFilterModal
            v-model="modals.filter"
            :size="'small'"
            :targetRef="filterButton"
            position="right"
            :title="`${userInfo.name}(${userInfo.id})`"
            :showFooter="true"
            :bgColor="'#eee'"
          >
            <UiFormLayout>
              <UiFormItem :label="t('common.userSettings.language')">
                <UiSegment
                  size="small"
                  v-model="selectedLang"
                  @update:model-value="handleLangChange"
                  :options="filteredLangOptions"
                />
              </UiFormItem>
              <UiFormItem :label="t('common.userSettings.mainPage')">
                <UiButton
                  class="main-page-select-btn"
                  variant="secondary"
                  size="small"
                  @click="
                    openModal('fullMenu');
                    isMainPageChange = true;
                    closeModal('filter');
                  "
                >
                  <div class="flex align-center gap-5 main-page-btn-content">
                    <span class="main-page-btn-label">
                      {{ selectedMainPageDisplayName || t('common.userSettings.configureMainPage') }}
                    </span>
                    <Icon class="main-page-btn-icon" name="mdi:chevron-right" size="20" />
                  </div>
                </UiButton>
              </UiFormItem>
              <template v-if="userType !== 'ADMIN'">
                <!-- 베타오픈 기간동안 개인 on/off 설정 불가능-->
                <!-- <UiFormItem v-if="compSaiUseYn === 'Y'" :label="`AI실험실(Sai)-${userSettings.aiSaiUseYn}`">
                  <UiSegment
                    size="small"
                    v-model="userSettings.aiSaiUseYn"
                    @click="changeAiSaiUseYn()"
                    :options="[
                      { value: 'Y', label: 'ON' },
                      { value: 'N', label: 'OFF' },
                    ]"
                  />
                </UiFormItem> -->
                <UiFormItem :label="t('common.userSettings.emailNotification')">
                  <UiSegment
                    size="small"
                    v-model="userSettings.mailReceiveYn"
                    @click="changeMailSet()"
                    :options="[
                      { value: 'Y', label: 'ON' },
                      { value: 'N', label: 'OFF' },
                    ]"
                  />
                </UiFormItem>
                <UiFormItem>
                  <template #label>
                    <span>{{ t('common.userSettings.pushNotification') }}</span>
                    <UiTooltip position="bottom-right" trigger="click" fixed>
                      <template #trigger>
                        <span class="notify-warning-icon" @click="showNotifyInfo">!</span>
                      </template>
                      {{ t('common.userSettings.pushNotificationDenied') }}
                    </UiTooltip>
                  </template>
                  <UiSegment
                    size="small"
                    v-model="userSettings.pushYnWeb"
                    @click="changeNotifySet()"
                    :options="[
                      { value: 'Y', label: 'ON' },
                      { value: 'N', label: 'OFF' },
                    ]"
                  />
                </UiFormItem>
                <UiFormItem :label="t('common.userSettings.slackNotification')">
                  <UiSegment
                    size="small"
                    v-model="userSettings.connectYn"
                    @click="openSlackConnect()"
                    :options="[
                      { value: 'Y', label: 'ON' },
                      { value: 'N', label: 'OFF' },
                    ]"
                  />
                </UiFormItem>
                <UiFormItem v-if="showAiTokenQuota" :label="t('common.userSettings.remainToken')">
                  <div class="token-quota-bar" :title="tokenQuotaTooltip">
                    <div class="token-quota-bar__track">
                      <div class="token-quota-bar__fill" :style="{ width: `${aiTokenRemainPercent}%` }" />
                    </div>
                  </div>
                </UiFormItem>
              </template>
            </UiFormLayout>

            <!-- 이렇게 푸터 슬롯을 타겟팅합니다 -->
            <template #footerActions>
              <div class="status-bar">
                <div class="status-bar__time">
                  <span class="status-bar__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                  </span>
                  <span class="status-bar__time-text">{{ t('common.userSettings.sessionTime', { time: formatSessionTime(displaySessionTime) }) }}</span>
                </div>
                <div class="status-bar__action">
                  <span class="status-bar__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                      <polyline points="16 17 21 12 16 7"></polyline>
                      <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                  </span>
                  <span class="status-bar__action-text" @click="handleLogout">{{ t('common.userSettings.logout') }}</span>
                </div>
              </div>
            </template>
          </UiFilterModal>
        </div>

        <!-- 알림: 아바타 바로 왼쪽(order 1) — 빨간 배지가 우측으로 삐져나오므로 여백 추가 -->
        <div style="position: relative; order: 1; margin-right: 8px">
          <!-- 알림 아이콘 및 카운트 -->
          <div class="notification-wrapper" v-if="auth.user?.unreadNotificationCnt > 0">
            <span class="notification-count">
              <!-- 읽지 않은 알림 개수 (100개 이상이면 99+로 표시) -->
              {{ auth.user?.unreadNotificationCnt >= 100 ? '99+' : auth.user?.unreadNotificationCnt }}
            </span>
          </div>
          <button class="icon-button" :title="t('common.header.notifications')" @click="openModal('notification')">
            <Icon name="heroicons:bell" size="22" />
          </button>
          <div class="notification-modal">
            <UiModal :title="t('common.header.notifications')" v-model="modals.notification" position="right" :size="'small'">
              <template #headerActions-right>
                <div class="flex gap-5 mr-10 mr-20 modal-header-actions align-center justify-start">
                  <UiButton variant="ghost" iconOnly :title="t('common.header.notificationPanel.refresh')" @click="handleNotificationRefresh">
                    <Icon name="mdi:refresh" size="20" />
                  </UiButton>
                  <UiButton variant="ghost" iconOnly :title="t('common.header.notificationPanel.markAllRead')" @click="$store.updateNotification('ALL', '0')">
                    <Icon name="mdi:check-all" size="20" />
                  </UiButton>
                  <UiButton variant="ghost" iconOnly :title="t('common.header.notificationPanel.deleteAll')" @click="$store.deleteNotification('ALL', '0')">
                    <Icon name="mdi:delete-outline" size="20" />
                  </UiButton>
                </div>
              </template>
              <div ref="notificationsContainerRef" class="notifications-container" @scroll="notificationScroll.handleScroll">
                <a
                  href="javascript:void(0);"
                  style="display: block"
                  :style="notification.notifyGbnCd == 'SYS' ? 'background: #f5fcff;' : ''"
                  v-for="(notification, index) in notifications"
                  :key="index"
                  :class="[
                    'notification-card',
                    `notification-status-${notification.status}`,
                    {
                      'notification-read': notification.read,
                    },
                  ]"
                  @click.prevent="onNotificationCardClick(notification)"
                >
                  <div class="notification-header">
                    <div class="notification-sender">
                      <i class="icon-user-gray icon-xl"></i>
                      <span class="sender-name">{{ notification.sender }}</span>
                    </div>
                    <span class="notification-time">{{ notification.time }}</span>
                  </div>
                  <p class="notification-title" :class="`notification-status-${notification.status}`">
                    {{ getNotificationTitle(notification) }}
                  </p>
                  <div class="notification-content">
                    {{ getNotificationContent(notification) }}
                  </div>
                  <div class="notification-actions" v-if="notification.notifyGbnCd != 'SYS'">
                    <UiButton
                      variant="ghost"
                      size="small"
                      iconOnly
                      @click.stop.prevent="$store.deleteNotification(notification.notifyGbnCd, notification.id)"
                    >
                      <Icon name="mdi:delete-outline" size="20" />
                    </UiButton>
                  </div>
                </a>

              <!-- 로딩 인디케이터 -->
              <div v-if="notificationScroll.isLoading.value && notifications.length > 0" class="notification-loading">
                <span>{{ t('common.header.notificationPanel.loading') }}</span>
              </div>

              <!-- 알림 예시 -->
              <div v-if="notifications.length === 0 && !notificationScroll.isLoading.value" class="no-notifications">
                <Empty
                  iconType="notification"
                  :title="t('common.header.notificationPanel.emptyTitle')"
                  :description="t('common.header.notificationPanel.emptyDescription')"
                />
              </div>
            </div>
          </UiModal>
          </div>
        </div>

        <!-- 전체 메뉴 모달 (전체메뉴 진입은 더보기 드롭다운으로 이동) -->
        <div class="full-menu-modal">
          <UiModal v-model="modals.fullMenu" :size="'full'">
            <template #title>
              <div class="flex align-center gap-5 justify-between">
                <div class="left-area">
                  <span>{{ t('common.header.fullMenuModal.title') }}</span>
                </div>
              </div>
            </template>
            <template #headerActions-right>
              <div class="flex align-center gap-10">
                <div v-if="isMainPageChange">
                  <span class="menu-description">{{ t('common.header.fullMenuModal.selectMainPage') }}</span>
                </div>
                <div v-else>
                  <span class="menu-description">{{ t('common.header.fullMenuModal.clickToNavigate') }}</span>
                </div>
                <UiSwitch v-model="isMainPageChange" :label="t('common.header.fullMenuModal.changeMainPage')" />
              </div>
            </template>

            <div class="full-menu-grid">
              <div v-for="(section, sectionIndex) in menuSections" :key="sectionIndex" class="menu-section">
                <div class="flex align-center gap-5">
                  <Icon :name="section.icon" size="32" />
                  <h3 class="menu-section-title">{{ section.title }}</h3>
                </div>
                <div class="menu-items-grid">
                  <a
                    v-for="(item, itemIndex) in section.items"
                    :key="itemIndex"
                    href="#"
                    class="menu-item"
                    :class="{
                      'selected-main-page': isMainPageChange && selectedMainPage?.path === item.path,
                      disabled: item.disabled,
                    }"
                    @click="handleMenuClick(item, $event)"
                  >
                    <span class="menu-item-name">{{ item.name }}</span>
                    <!-- 메인페이지 변경 모드일 때만 체크마크 표시 -->
                    <Icon v-if="isMainPageChange && selectedMainPage?.path === item.path" name="mdi:check" size="16" class="check-icon" />
                  </a>
                </div>
                <div v-if="section.submenus" class="submenu-grid">
                  <div v-for="(submenu, submenuIndex) in section.submenus" :key="submenuIndex" class="submenu-section">
                    <h4 class="submenu-section-title">{{ submenu.title }}</h4>
                    <div class="submenu-items-grid">
                      <a
                        v-for="(submenuItem, submenuItemIndex) in submenu.items"
                        :key="submenuItemIndex"
                        href="#"
                        class="submenu-item"
                        :class="{
                          'selected-main-page': isMainPageChange && selectedMainPage?.path === submenuItem.path,
                          disabled: submenuItem.disabled,
                        }"
                        @click="handleMenuClick(submenuItem, $event)"
                      >
                        <span class="submenu-item-name">{{ submenuItem.name }}</span>
                        <!-- 메인페이지 변경 모드일 때만 체크마크 표시 -->
                        <Icon v-if="isMainPageChange && selectedMainPage?.path === submenuItem.path" name="mdi:check" size="16" class="check-icon" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </UiModal>
        </div>
      </div>
    </div>

    <!-- SAI 모달 -->
    <SaiChat v-model="saiChatStore.isSaiModalOpen" />

    <NoticeBoardModal />
    <LoginPopNoticeModal />
    <QnaBoardModal />
  </header>
</template>

<script setup>
import { computed, inject, onBeforeUnmount, onMounted, provide, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
/****************************************************
 * 알람 관련
 ****************************************************/
/****************************************************
 *  설정 관련
 ****************************************************/
import { useRealTime } from '~/composables/useRealTime';
import { usePageTitle } from '~/composables/usePageTitle';
import { resolveMenuTabLabel } from '~/config/tabMenuConfig';
import { useApi } from '~/composables/useApi';
import { useAuthStore } from '~/stores/useAuthStore';
import { navigateWithAppLocale } from '~/composables/useAppLocale';
import SaiChat from './saiChat.vue';

const COMP_ICON_YN_STORAGE_KEY = 'compIconYn';

const { isNotEmpty } = useCommon();

// 페이지 타이틀 가져오기
const { pageTitle } = usePageTitle();

// 현재 라우트 가져오기
const route = useRoute();

const { t, locale } = useI18n();

// 탭 네비게이션 사용
const { activeTab, currentTabs, handleTabChange, getCurrentMenuItem, logTabMenuAccess } = useTabNavigation();

// 디버깅: activeTab 변경 감지
watch(activeTab, (newVal, oldVal) => {
  console.log('🔵 TheHeader activeTab 변경:', { oldVal, newVal });
});

const currentMenuItem = computed(() => getCurrentMenuItem());

// useMenuSections에서 탭 정보를 가져와서 현재 경로에 맞는 탭 메뉴 결정
const currentTabMenu = computed(() => {
  void locale.value;
  if (currentTabs.value && currentTabs.value.length > 0) {
    return currentTabs.value.map(tab => ({
      name: resolveMenuTabLabel(tab, t),
      path: tab.path || route.path.replace('/screens', ''),
    }));
  }

  return [];
});

/****************************************************
 * 사용자 관련 (useUserStore에서 모달 상태도 가져옴)
 ****************************************************/
const {
  isMainPageChange,
  selectedMainPage,
  selectedMainPageDisplayName,
  userInfo,
  userSettings,
  langOptions,
  selectedLang,
  userType,
  compSaiUseYn,
  notifyWarning,
  filterButton,
  // betaFeatures, // 개인 SAI 설정(aiSaiUseYn) 체크용. 헤더 버튼은 compSaiUseYn + 전체관리자(01)만 사용
  init,
  changeMailSet,
  changeNotifySet,
  changeLang,
  changeAiSaiUseYn,
  openSlackConnect,
  showNotifyInfo,
  setMainPage,
  userAiTokenStatus,
  showAiTokenQuota,
  aiTokenRemainPercent,
  fetchUserAiTokenStatus,
  // 모달 관련
  modals,
  openModal,
  closeModal,
  toggleModal,
  closeAllModals,
} = useUserStore();

// 한글·영문만 표시 (레거시 UI: 한글 / ENG)
const filteredLangOptions = computed(() => {
  const labelMap = {
    ko: '한글',
    en: 'ENG',
  };

  return langOptions.value
    .filter(option => ['ko', 'en'].includes(option.value))
    .map(option => ({
      ...option,
      label: labelMap[option.value] || option.label,
    }));
});

const handleLangChange = async lang => {
  selectedLang.value = lang;
  await changeLang(currentMenuItem.value?.pgmId);
};

const getNotificationTitle = notification => String(notification?.title ?? '').trim();

const getNotificationContent = notification => String(notification?.content ?? '').trim();

const userProfileTooltip = computed(() => {
  const { name, position, department } = userInfo.value;
  const nameWithPosition = [name, position].filter(Boolean).join(' ');
  return department ? `${nameWithPosition} (${department})` : nameWithPosition;
});

const tokenQuotaTooltip = computed(() => {
  const { remainToken, limitToken, usageRate } = userAiTokenStatus.value;
  if (!limitToken) {
    return t('common.userSettings.tokenQuotaEmpty');
  }
  return t('common.userSettings.tokenQuotaTooltip', {
    remain: remainToken.toLocaleString(),
    limit: limitToken.toLocaleString(),
    rate: usageRate,
  });
});

const auth = useAuthStore();
const runtimeConfig = useRuntimeConfig();
const { popNotice, handleCheckPopNotice } = useNoticeBoardStore();
const { popQnA } = useQnaBoardStore();

/** Pinia 초기화·checkAuth 대기 중에도 localStorage로 표시 여부 유지 (ASIS↔TOBE 전환) */
const compIconYn = computed(() => {
  if (auth.compIconYn) {
    return auth.compIconYn;
  }
  if (!import.meta.client) {
    return '';
  }
  try {
    return localStorage.getItem(COMP_ICON_YN_STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
});

const showCompIcon = computed(() => compIconYn.value === 'Y' && !!auth.user?.compId);

const compIconUrl = computed(() => {
  const compId = auth.user?.compId;
  if (!showCompIcon.value || !compId) {
    return '';
  }
  /* 로컬 /api 프록시 */
  const prefix = runtimeConfig.public.isDev ? '/api' : '';
  return `${prefix}/common/compIcon.do?compId=${encodeURIComponent(compId)}`;
});

watch(
  () => auth.compIconYn,
  yn => {
    if (!yn && import.meta.client) {
      auth.restoreCompIconYnFromStorage();
    }
  },
  { immediate: true },
);

// 탭 클릭 핸들러
const handleTabClick = index => {
  handleTabChange(index);
};

// 현재 메뉴에 manualUrl이 있는지 확인
const menuStore = useMenuStore();
const menuSections = computed(() => menuStore.sections);
const { navigateToHome } = useHomeNavigation();

/** 로고 클릭: viewType A → /main.do#pgmId, T → TOBE path (사이드바와 동일) */
const handleLogoClick = () => navigateToHome();

const handlePageRefresh = () => {
  if (process.client) {
    window.location.reload();
  }
};

const goAsisService = () => {
  if (!import.meta.client) {
    return;
  }
  window.location.href = '/common/asisSsoLogin.do';
};

/** SR 문의 SSO 연동 (서버 리다이렉트 엔드포인트 호출) */
const goSrsysSsoLogin = () => {
  if (!import.meta.client) {
    return;
  }

  const ssoWindow = window.open('about:blank', '_blank');
  if (!ssoWindow) {
    showAlert(t('common.alert'), t('common.header.popupBlocked'));
    return;
  }

  const serviceId = auth.user?.compId === 'ispark' ? 'srsysIspark' : 'srsys';
  ssoWindow.location.href = `/common/ssoRedirect.do?serviceId=${serviceId}`;
};

/****************************************************
 * SSO 연동서비스 바로가기
 ****************************************************/
const ssoServiceId = ref('');
const ssoServiceOptions = computed(() =>
  (auth.ssoServiceList || []).map(item => ({
    value: item.apiServiceId,
    label: item.apiServiceNm,
  })),
);

const handleSsoLogin = async selectedId => {
  const serviceId = selectedId || ssoServiceId.value;
  if (!import.meta.client || !isNotEmpty(serviceId)) {
    return;
  }

  try {
    const params = new URLSearchParams();
    params.append('serviceId', serviceId);

    const res = await useApi('/api/common/ssoUrl.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });

    if (!isNotEmpty(res?.ssoUrl)) {
      showAlert(t('common.alert'), res?.ssoErrorMsg || t('common.header.ssoLinkError'));
      ssoServiceId.value = '';
      return;
    }

    window.open(res.ssoUrl, '_blank');
  } catch (e) {
    console.error(e);
  } finally {
    ssoServiceId.value = '';
  }
};

/****************************************************
 * 도움말 드롭다운 (전체메뉴/공지/Q&A/매뉴얼/자주 묻는 질문)
 ****************************************************/
const openManualPopup = () => {
  const manualUrl = 'https://strategygate.notion.site/Sgate-11274c51396980c1b8adf56262517440?pvs=4';
  window.open(manualUrl, '_blank');
};

const openFaqPopup = () => {
  const faqUrl = 'https://strategygate.notion.site/Sgate-Ver-3ec74c513969800483dbe34551c35432';
  window.open(faqUrl, '_blank');
};
const isHelpMenuOpen = ref(false);
const helpMenuRef = ref(null);

const toggleHelpMenu = () => {
  isHelpMenuOpen.value = !isHelpMenuOpen.value;
};
const closeHelpMenu = () => {
  isHelpMenuOpen.value = false;
};

// 드롭다운 바깥 클릭 시 닫기
const handleHelpMenuOutsideClick = event => {
  if (!isHelpMenuOpen.value) return;
  if (helpMenuRef.value && !helpMenuRef.value.contains(event.target)) {
    closeHelpMenu();
  }
};

// SAI 채팅 스토어 사용
const saiChatStore = useSaiChatStore();

// SAI 모달 상태를 레이아웃에 제공
provide('isSaiModalOpen', saiChatStore.isSaiModalOpen);

const handleMenuClick = async (item, event) => {
  event.preventDefault(); // 항상 기본 동작 막기

  // disabled 메뉴는 클릭 무시
  if (item.disabled || !item.path || item.path === '#') {
    console.log('⚠️ Disabled menu clicked, ignoring');
    return;
  }

  if (isMainPageChange.value) {
    setMainPage(item.path, item.name);
    showAlert(t('common.alert'), t('common.header.fullMenuModal.mainPageChanged'));
  } else {
    auth.refreshUnreadNotificationCnt();
    try {
      await navigateWithAppLocale(item.path);
      if (!item.tabs?.length) {
        logTabMenuAccess('', item.pgmId || '');
      }
      closeModal('fullMenu');
    } catch (error) {
      console.error('❌ Navigation failed:', error);
    }
  }
};

const webSocketStore = useWebSocketStore();

const handleLogout = () => {
  // 다른 탭/브라우저에 로그아웃 알림 전송
  // const logoutMessage = {
  //   messageType: 'LOGOUT',
  //   currentTabId: webSocketStore.currentTabId,
  // };
  //
  // // WebSocket과 BroadcastChannel로 로그아웃 메시지 전송
  // webSocketStore.send(logoutMessage);
  // webSocketStore.broadcast(logoutMessage);

  // 로그아웃 처리
  auth.logout();
};

const $store = useNotificationStore();
const {
  notifications,
  loadNotifications,
  loadMoreNotifications,
  resetNotifications,
  handleReadNotification,
  preserveNotificationPanel,
  notificationScrollTop,
} = $store;

const notificationsContainerRef = ref(null);

const onNotificationCardClick = async notification => {
  if (modals.notification && notificationsContainerRef.value) {
    notificationScrollTop.value = notificationsContainerRef.value.scrollTop;
  }
  await handleReadNotification(
    notification.notifyGbnCd,
    notification.gbnCd,
    notification.id,
    notification.linkId,
    notification.path,
    notification.realCreateDt,
    notification.pgmId,
  );
};

// 알림 무한 스크롤 설정
const notificationScroll = useInfiniteScroll(
  async page => {
    return await loadMoreNotifications(page);
  },
  {
    initialPage: 1,
    rowsPerPage: 10,
    scrollMargin: 50,
  },
);

onMounted(async () => {
  await init(); //사용자 정보 조회(알림 정보)
  auth.refreshUnreadNotificationCnt();

  // 로그인 성공 직후 1회만 공지 팝업 조회 (새로고침 시에는 미실행)
  const shouldShowLoginPopNotice = sessionStorage.getItem('sgate:showLoginPopNotice') === 'Y';
  if (shouldShowLoginPopNotice) {
    sessionStorage.removeItem('sgate:showLoginPopNotice');
    await handleCheckPopNotice();
  }
  // 사용자 이미지 초기화 (미들웨어에서 처리되지 않은 경우 대비)
  const { useUserImgsStore } = await import('~/composables/useUserImgsStore');
  const userImgsStore = useUserImgsStore();

  if (userInfo.value && !userImgsStore.isInitialized) {
    console.log('Header: Initializing user images as fallback');
    try {
      await userImgsStore.initializeUserImages();
      console.log('Header: User images initialized successfully');
    } catch (error) {
      console.warn('Header: Failed to initialize user images:', error);
    }
  }

  // 도움말 드롭다운 바깥 클릭 감지
  document.addEventListener('click', handleHelpMenuOutsideClick);
});

const { currentTime } = useRealTime();

/****************************************************
 * 필터 모달 관련
 ****************************************************/
// 세션 남은 시간 관리
const displaySessionTime = ref(0);
const sessionTimerInterval = ref(null);

// 초를 시:분:초 형식으로 변환
const formatSessionTime = seconds => {
  if (seconds < 0) seconds = 0;

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

// 타이머 시작
const startSessionTimer = () => {
  // 기존 타이머가 있으면 정리
  if (sessionTimerInterval.value) {
    clearInterval(sessionTimerInterval.value);
  }

  // 1초마다 감소
  sessionTimerInterval.value = window.setInterval(() => {
    if (displaySessionTime.value > 0) {
      displaySessionTime.value--;
    }
  }, 1000);
};

// 타이머 정지
const stopSessionTimer = () => {
  if (sessionTimerInterval.value) {
    clearInterval(sessionTimerInterval.value);
    sessionTimerInterval.value = null;
  }
};

// 모달 상태 감시 - 필터 모달 (세션 시간)
watch(
  () => modals.filter,
  async isOpen => {
    if (isOpen) {
      // 모달이 열렸을 때: checkAuth 호출하여 서버와 동기화
      // 세션 만료 시 checkAuth 내부에서 자동으로 다이얼로그 표시
      const isValid = await auth.checkAuth();
      if (!isValid) {
        closeModal('filter');
        return;
      }

      // 서버에서 받아온 sessionLeftTime을 displaySessionTime에 설정
      displaySessionTime.value = auth.user?.sessionLeftTime || 0;

      // 타이머 시작
      startSessionTimer();

      if (showAiTokenQuota.value) {
        await fetchUserAiTokenStatus();
      }
    } else {
      // 모달이 닫혔을 때: 타이머 정지
      stopSessionTimer();
    }
  },
);

// 모달 상태 감시 - 알림 모달 (알림 목록)
watch(
  () => modals.notification,
  async isOpen => {
    if (!isOpen) return;

    // 알림 클릭 후 페이지 이동으로 닫혔다 열릴 때 — 목록·스크롤 유지
    if (preserveNotificationPanel.value) {
      preserveNotificationPanel.value = false;
      await nextTick();
      if (notificationsContainerRef.value) {
        notificationsContainerRef.value.scrollTop = notificationScrollTop.value;
      }
      return;
    }

    resetNotifications();
    notificationScroll.reset();
    await loadNotifications();
  },
);

// 알림 새로고침 핸들러
const handleNotificationRefresh = async () => {
  resetNotifications();
  notificationScroll.reset();
  await loadNotifications();
};

// 컴포넌트 언마운트 시 타이머 정리
onBeforeUnmount(() => {
  stopSessionTimer();
  document.removeEventListener('click', handleHelpMenuOutsideClick);
});

function openUserInfoModal() {
  toggleModal('filter');
}

/****************************************************
 * 바로가기 관련
 ****************************************************/

function openManualUrl() {
  const manualUrl = currentMenuItem.value?.manualUrl;
  if (isNotEmpty(manualUrl)) {
    const name = 'manualPop';
    const option = 'width=900, height=800, top=100, left=200, status=no, location=no, toolbar=no, menubar=no, directories=0';
    window.open(manualUrl, name, option);
  }
}

function handleUserImgError(e) {
  const img = e.target;
  img.src = '/images/icon-gnb-my.svg';
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 54px;
  background-color: white;
  border-bottom: 1px solid #aaa;
  position: fixed;
  top: 0;
  left: 0;
  /* 송기준 수정: GNB가 사이드바(950)·UiSelect 드롭다운(940)보다 위 — 탭/로고 영역 유지. 모달(1000)보다는 낮게 */
  z-index: 960;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 17px;
  height: 100%;
  margin: 0 auto;
}

.logo {
  display: flex;
  align-items: center;
  margin-right: 5px;

  .title-area {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .title {
    margin: 0 12px;
    font-size: $font-size-xxl; // 20px
    font-weight: 700;
    color: #1e2124;
    flex: none;
  }

  a {
    display: inline-block;
    flex: none;
  }
}

.logo a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
}

.logo a img {
  max-height: 46px; // 48px 헤더에 맞춰 로고 높이 (깨지지 않게)
  width: auto;
}

.logo-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.logo-text {
  font-weight: bold;
  font-size: 16px;
}

/* 탭 메뉴 스타일 */
.tab-menu {
  flex: 1;
  display: flex;
  height: 100%;
  max-height: 50px;
  align-self: end;
}

.tabs {
  display: flex;
  height: 100%;
}

.tab {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 14px;
  color: #b1b8bd;
  text-decoration: none;
  font-size: 17px;
  font-weight: 700;
  position: relative;
  transition: color 0.2s;
  border: none;
  background: none;
  cursor: pointer;
}

.tab:hover {
  background: var(--color-primary-5, #e5f6ff);
  color: #464c53;
}

.tab.active {
  color: #1e2124;
  font-weight: 800;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: $primary-color;
}

.main-logo {
  width: 46px;
  display: flex;
  align-items: center;
  margin-right: 8px;

  img {
    max-width: 100%;
    object-fit: contain;
  }
}

.icon-menu {
  display: flex;
  align-items: center;
  gap: 6px; /* 아이콘 간 균일 간격 */
  min-width: 180px; /* 아이콘 메뉴 영역 최소 너비 */
  justify-content: flex-end;
}

.sso-service-select {
  margin-right: 11px;
  min-width: 160px;
}

.asis-shortcut-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  padding: 5px 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600; // 헤더에서 묻히지 않도록 굵게
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;

  // 오류·개선 제안: 주황 계열 강조
  &--report {
    border-color: #fed7aa;
    background: #fff7ed;
    color: #c2410c;

    &:hover {
      background: #ffedd5;
      border-color: #fdba74;
    }
  }

  // 기존 sgate 이용하기: 파랑 계열 강조
  &--asis {
    border-color: #bfdbfe;
    background: #eff6ff;
    color: #1d4ed8;

    &:hover {
      background: #dbeafe;
      border-color: #93c5fd;
    }
  }
}

/* 모달 전용 래퍼: 레이아웃 박스를 만들지 않도록 (빈 flex 아이템이 간격을 벌리는 것 방지) */
.full-menu-modal {
  display: contents;
}

.icon-button {
  background: none;
  border: none;
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #5a6168; // 통일된 라인 아이콘 단색 (heroicons currentColor 상속)
}
.icon-button:hover {
  background-color: #e8e8e8;
  color: #1e2124; // 호버 시 진하게
}

.sai-button {
  position: relative;
  overflow: visible;
}

.sai-beta-badge {
  position: absolute;
  top: -6px;
  left: 52%;
  z-index: 2;
  transform: translateX(-50%);
  padding: 1px 5px;
  border-radius: 999px;
  background: linear-gradient(90deg, #2f6bff 0%, #6d4aff 100%);
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.01em;
  white-space: nowrap;
  pointer-events: none;
}
.icon-button.is-active {
  background-color: #e8e8e8;
  color: #1e2124; // 드롭다운 열림 상태
}

/* 도움말 드롭다운 */
.help-menu {
  position: relative;
  display: flex;
  align-items: center;
  order: 3; // 우측 클러스터 맨 끝(더보기/오버플로우 관례)
}

.help-menu__dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 970; // 헤더(960) 위
  min-width: 208px;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}

.help-menu__item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: none;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.help-menu__item:hover {
  background: #f3f4f6;
}

.help-menu__icon {
  flex-shrink: 0;
  color: #5a6168; // 라인 아이콘 단색 통일
}

.help-menu__label {
  flex: 1;
}

.help-menu__chevron {
  flex-shrink: 0;
  color: #c4cad0; // 옅은 chevron
}

.help-menu__divider {
  height: 1px;
  margin: 4px 8px;
  background: #eef1f5;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .tab-menu {
    overflow-x: auto;
    justify-content: flex-start;
  }

  .tab {
    padding: 0 12px;
    white-space: nowrap;
  }

  .icon-menu {
    min-width: auto;
  }
}
.notify-warning-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  border-radius: 50%;
  background-color: #f5a623;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  vertical-align: middle;
}

.status-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  font-size: $font-size-sm;
  color: $text-color;
  padding: 0 8px;

  &__item {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 12px;
    gap: 8px;
  }

  &__time {
    flex: 1;
    border-right: 1px solid $border-color;
    padding-right: 12px;
    display: flex;
    align-items: center;
  }

  &__action {
    justify-content: center;
    flex: 1;
    cursor: pointer;
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;
  }

  &__icon {
    display: flex;
    align-items: center;
    margin-right: 6px;
    color: $icon-color;
  }

  &__text {
    font-weight: 400;
  }

  &__time-text {
    letter-spacing: 0.5px;
  }

  &__action-text {
    font-weight: 500;
  }
}

.notifications-container {
  overflow-y: auto;
  max-height: calc(100vh - 120px);

  .notification-loading {
    padding: 12px;
    text-align: center;
    color: #999;
    font-size: $font-size-sm;
  }

  .notification-card {
    padding: 12px;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f8f8f8;
    }

    .notification-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;

      .notification-sender {
        display: flex;
        align-items: center;
        gap: 6px;

        .sender-icon {
          color: #666;
        }

        .sender-name {
          font-weight: 700;
          font-size: $font-size-md;
          color: #333;
        }
      }

      .notification-time {
        font-size: 12px;
        color: #999;
      }
    }

    .notification-title {
      font-size: $font-size-md;
      font-weight: 700;
      color: #333;
      margin-bottom: 8px;
      &.notification-status-info {
        color: #3498db;
      }

      &.notification-status-success {
        color: #34a853;
        font-weight: 600;
      }

      &.notification-status-warning {
        color: #f39c12;
        font-weight: 600;
      }
    }

    .notification-content {
      font-size: $font-size-md;
      color: $text-color;
      margin-bottom: 8px;
      font-weight: 500;
      line-height: 1.4;
    }

    .notification-actions {
      display: flex;
      justify-content: flex-end;
      gap: 4px;
    }
  }

  .no-notifications {
    padding: 24px;
    text-align: center;
    color: #999;
    font-size: $font-size-md;
  }
}
// 전체메뉴
.full-menu-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  overflow-x: auto;
  max-width: 100%;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
    min-width: 800px; // 최소 너비 설정
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    min-width: 500px; // 최소 너비 설정
  }
}

.menu-section {
  display: flex;
  flex-direction: column;
  padding: 12px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  min-width: 180px; // 최소 너비 설정

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  }

  .flex.align-center.gap-5 {
    margin-bottom: 10px;
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 5px;
  }
  .menu-section-title {
    font-size: $font-size-md;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;

    .title-icon {
      margin-right: 8px;
      color: #3b82f6;
    }
  }

  .menu-items-grid {
    display: grid;
    grid-template-columns: 1fr;
  }

  .menu-item {
    padding: 3px;
    border-radius: 6px;
    text-decoration: none;
    transition: all 0.2s;
    display: flex;
    align-items: center;

    &:hover {
      background-color: #f0f7ff;
      color: #2563eb;
    }

    .menu-item-icon {
      margin-right: 8px;
      color: #6b7280;
    }

    .menu-item-name {
      font-size: $font-size-md;
      color: #4b5563;
      font-weight: 500;
      &::before {
        content: '· ';
        font-size: 16px;
        color: #6b7280;
        margin-right: 4px;
      }
    }

    /* Disabled 메뉴 스타일 */
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;

      .menu-item-name {
        color: #b1b8be;
      }

      &:hover {
        background-color: transparent;
        color: inherit;
      }
    }
  }
}

.submenu-grid {
  margin-top: 12px;
}

.submenu-section {
  display: flex;
  flex-direction: column;
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #eaeaea;
  border-radius: 6px;
  background-color: #f9fafb;

  .submenu-section-title {
    font-size: $font-size-md;
    font-weight: 500;
    color: #4b5563;
    margin: 4px 0 8px;
    display: flex;
    align-items: center;

    .title-icon {
      margin-right: 6px;
      color: #6b7280;
    }
  }
  .submenu-items-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    & > :last-child:nth-child(odd) {
      grid-column: 1 / -1; // 홀수 개수일 때 마지막 항목만 전체 너비를 차지하도록 설정
    }
  }

  .submenu-item {
    padding: 4px 0px;
    border-radius: 4px;
    text-decoration: none;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    word-break: keep-all;

    &:hover {
      background-color: #e0edff;
      color: #2563eb;
    }

    .submenu-item-icon {
      margin-right: 6px;
      color: #6b7280;
    }

    .submenu-item-name {
      font-size: 13px;
      color: #4b5563;
      &::before {
        content: '· ';
        font-size: 14px;
        color: #6b7280;
        margin-right: 3px;
      }
    }

    /* Disabled 서브메뉴 스타일 */
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;

      .submenu-item-name {
        color: #b1b8be;
      }

      &:hover {
        background-color: transparent;
        color: inherit;
      }
    }
  }
}

:deep(.ui-form-item__content) {
  display: flex;
  justify-content: flex-end;
}
:deep(.filter-footer) {
  padding: 4px 16px;
}
:deep(.ui-button--medium) {
  height: 36px;
}
:deep(.ui-form-layout .ui-button .iconify) {
  animation: moveRight 1.7s ease-in-out infinite;
}
:deep(.main-page-select-btn) {
  max-width: 120px;
}
:deep(.main-page-select-btn .ui-button__text) {
  display: block;
  width: 100%;
  min-width: 0;
}
:deep(.main-page-btn-content) {
  width: 100%;
  min-width: 0;
}
:deep(.main-page-btn-label) {
  display: block;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
:deep(.main-page-btn-icon) {
  flex-shrink: 0;
}
.ui-popup__title span {
  font-size: smaller;
  color: #666;
}
.has-link {
  margin-right: 12px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 30px;
  padding: 0 6px;
  border: none; // 박스 제거
  border-radius: 8px;
  background: transparent; // 박스 제거
  color: #5a6168;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    background-color: #f3f4f6; // hover 시 옅은 배경만
    color: #1e2124;
  }

  &.has-link-trail {
    margin-right: 8px;
  }
}

.has-link__label {
  white-space: nowrap;
}

.has-link__ext {
  color: #9ca3af; // 외부 이동(↗) 표시는 옅게
}
.notification-modal :deep(.ui-popup__header-actions) {
  width: 100%;
  align-items: center;
  gap: 9px;
  justify-content: space-between;
  margin-left: 20px;
}
.notification-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  /* 벨 아이콘(22px, icon-button 32px 중앙) 우측 상단 코너에 고정.
     right 기준 앵커라 숫자가 1자리든 99+든 오른쪽 끝은 그대로, 왼쪽으로만 늘어남 */
  top: -6px;
  right: -5px;
  z-index: 10; /* 벨 아이콘/주변 요소 위로 올려 항상 보이도록 */
  background-color: $system-red;
  border-radius: 9px;
  padding: 0 4px;
  border: 1.5px solid #fff; /* 벨 아이콘과 분리되도록 흰 테두리 */
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  min-width: 18px;
  height: 18px;
  box-sizing: border-box;
  text-align: center;
}
.notification-read {
  background-color: #f9f9f9; // 살짝 더 어두운 배경
  color: #888; // 더 연한 텍스트
  opacity: 0.3; // 전체적으로 흐릿하게
}
.menu-description {
  font-size: 14px;
  color: #666;
  font-weight: 400;
  position: relative;
  top: -1px;
}
.menu-item {
  position: relative;

  &.selected-main-page {
    background-color: #e3f2fd;
    border: 1px solid #2196f3;

    .menu-item-name {
      color: #1976d2;
      font-weight: 600;
    }
  }

  .check-icon {
    position: absolute;
    right: 8px;
    color: #4caf50;
  }
}

.token-quota-bar {
  width: 100%;
  max-width: 120px;
  margin-left: auto;
}

.token-quota-bar__track {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background-color: #e5e7eb;
  overflow: hidden;
}

.token-quota-bar__fill {
  height: 100%;
  border-radius: 4px;
  background-color: var(--primary-color, #00aaff);
  transition: width 0.2s ease;
}
</style>
